import request from "../../untils/request.js"


//分页
export const getWesternMedicineListPage = (params) => {
    return request.get('/outpatient/rxmain/page',{params})
}

export const getWesternMedicineStaticsPage = (params) => {
    return request.get('/outpatient/rxmain/statics',{params})
}

export const getWestRelatedMedicalOrders = (params) => {
    return request.get('/outpatient/doctoradvice/relatedList',{params})
}

export default{
}

